import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * La fila de buscar y filtrar de una pagina.
 *
 * Seis paginas tienen una, y **ninguna lleva lo mismo**: una trae dos filtros,
 * otra ninguno, otra tres buscadores. Por eso esto es solo el hueco —la fila y su
 * comportamiento al estrecharse— y no el contenido: envolver los filtros en una
 * abstraccion que adivine cuantos hay seria inventarse un problema que no existe.
 *
 *   <PageToolbar>
 *     <Input placeholder="Buscar" className="max-w-xs" />
 *     <Select>...</Select>
 *   </PageToolbar>
 *
 * **No lleva caja.** Es parte de la seccion, no un contenedor aparte: el criterio
 * de composicion (harness/skills/muveran-design/SKILL.md) da dos niveles y este
 * no es ninguno de los dos.
 */
const PageToolbar = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-wrap items-center gap-2", className)}
    {...props}
  >
    {children}
  </div>
))
PageToolbar.displayName = "PageToolbar"

export { PageToolbar }
